import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const emptyAddr = { label: "", recipient: "", address: "", zip: "", city: "", province: "", country: "Italia", is_default: false };

export const addrLine = (a) => {
  if (!a) return "";
  const l2 = [a.address, a.zip, a.city, a.province ? `(${a.province})` : ""].filter(Boolean).join(" ");
  return [l2, a.country && a.country !== "Italia" ? a.country : ""].filter(Boolean).join(" · ");
};

export function AddressFields({ value, onChange, showLabel = true }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {showLabel && (
        <div className="space-y-1.5 sm:col-span-2"><Label className="text-xs">Etichetta (es. Sede, Magazzino)</Label>
          <Input value={value.label || ""} onChange={set("label")} data-testid="addr-label" className="bg-brema-bg" /></div>
      )}
      <div className="space-y-1.5 sm:col-span-2"><Label className="text-xs">Destinatario / Ragione sociale</Label>
        <Input value={value.recipient || ""} onChange={set("recipient")} data-testid="addr-recipient" className="bg-brema-bg" /></div>
      <div className="space-y-1.5 sm:col-span-2"><Label className="text-xs">Indirizzo</Label>
        <Input value={value.address || ""} onChange={set("address")} data-testid="addr-address" className="bg-brema-bg" placeholder="Via, n. civico" /></div>
      <div className="space-y-1.5"><Label className="text-xs">CAP</Label>
        <Input value={value.zip || ""} onChange={set("zip")} data-testid="addr-zip" className="bg-brema-bg" /></div>
      <div className="space-y-1.5"><Label className="text-xs">Città</Label>
        <Input value={value.city || ""} onChange={set("city")} data-testid="addr-city" className="bg-brema-bg" /></div>
      <div className="space-y-1.5"><Label className="text-xs">Provincia</Label>
        <Input value={value.province || ""} onChange={set("province")} data-testid="addr-province" className="bg-brema-bg" placeholder="MI" /></div>
      <div className="space-y-1.5"><Label className="text-xs">Nazione</Label>
        <Input value={value.country || ""} onChange={set("country")} data-testid="addr-country" className="bg-brema-bg" /></div>
    </div>
  );
}
